import { DailyPlanMealDisplay } from "./DailyPlanMealDisplay";

export function DailyPlan({
  mealData,
  mealTypes,
  handleOpenModal,
  currentDayIndex,
  isPastWeek,
}) {
  return (
    <div className="px-4 pt-2">
      <DailyPlanMealDisplay
        mealData={mealData}
        handleOpenModal={handleOpenModal}
        currentDayIndex={currentDayIndex}
        mealTypes={mealTypes}
        isPastWeek={isPastWeek}
      />
    </div>
  );
}
